import { ValidateNumber } from "@/util/ValidationUtil.ts";

export class ChargerCapacitySpec {
    /**
     * 충전기 용량
     * */
    @ValidateNumber("")
    capacity: number;
    /**
     * 충전기 수
     * */
    @ValidateNumber("")
    count: number;

    constructor(data?: Partial<ChargerCapacitySpec>) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.capacity = 0;
            this.count = 0;
        }
    }
}
